import React from 'react';
import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default ({powerCapacity, isFinalReview, goToStep, boatDetailsRequestInProcess}) => {
  if (boatDetailsRequestInProcess) return null;
  if (!powerCapacity) return null;

  let value = '';
  if (powerCapacity.maxSpeedLessThan30) value = 'Less Than 30';
  else if (powerCapacity.passesTestAtFullPower) value = 'More Than 30';
  else value = (+powerCapacity.maneuveringSpeed || 0).toFixed(0);

  return (
    <section className='scene_section'>
      <header>Max Power Capacity Data</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Maneuvering Speed'
        value={value}
        units=' Mph'
        decimalDigits={0}
      />
      {isFinalReview && (
        <Button
          color={buttonColor.planeOrange}
          label='Edit'
          buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
          fontSize={14}
          onClick={() => goToStep(STEP_ID.POWER_CAPACITY, true)}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/PowerCapacity.jsx